const people = [
  {
    section: "ベンチマーク1",
    spec: "CPU: 1 Core／メモリ: 0.6 GB",
    name: "スループット",
    title: "520/分",
    email: "不可",
    role: "不可",
  },
  {
    section: "ベンチマーク2",
    spec: "CPU: 4 Core／メモリ: 7.5 GB",
    name: "スループット",
    title: "920/分",
    email: "520/分",
    role: "650/分",
  },
];

export default function SpeedCmsPointsTable() {
  return (
    <div className="mt-2 overflow-x-auto md:mt-4">
      <div className="inline-block min-w-full align-middle">
        <div className="overflow-hidden shadow md:rounded-lg">
          <table className="min-w-full border border-solid border-bdc-light">
            <thead className="bg-bgc-dark">
              <tr>
                <th scope="col"></th>
                <th
                  scope="col"
                  className="border-x-4 border-solid border-sec bg-sec px-3 py-2 text-center font-bold text-white fluid-text-[16px,22px]"
                >
                  SpeedCMS
                </th>
                <th
                  scope="col"
                  className="px-3 py-2 text-center font-bold text-txt-light fluid-text-[11px,14px]"
                >
                  A社 CMS
                </th>
                <th
                  scope="col"
                  className="px-3 py-2 text-center font-bold text-txt-light fluid-text-[11px,14px]"
                >
                  B社 CMS
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-solid divide-bdc-light bg-white">
              {people.map((person) => (
                <tr key={person.email} className="border-x-0">
                  <td className="whitespace-nowrap border-y-0 py-3 pl-4 pr-3 font-bold text-gray-900 fluid-text-[12px,18px] sm:pl-6">
                    <p className="text-ter fluid-text-[10px,14px]">
                      {person.section}
                    </p>
                    <p className="text-ter fluid-text-[12px,18px]">
                      {person.spec}
                    </p>
                    <h4 className="text-pri fluid-text-[16px,22px]">
                      {person.name}
                    </h4>
                  </td>
                  <td className="whitespace-nowrap border-x-4 border-b-4 border-solid border-sec p-3 text-center font-bold text-pri fluid-text-[18px,26px]">
                    {person.title}
                  </td>
                  <td className="whitespace-nowrap border-y-0 p-3 text-center font-bold text-txt-base fluid-text-[14px,18px]">
                    {person.email}
                  </td>
                  <td className="whitespace-nowrap border-y-0 border-r-0 border-l border-solid border-bdc-light p-3 text-center font-bold text-txt-base fluid-text-[14px,18px]">
                    {person.role}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
